import styled, { css } from 'styled-components';
import { FlexCenterAligned, FlexColumn } from '../../../styled/common';
import { Z_INDEX_TO_HIDE_BANNERS } from '../../../utils/helpers/constants';

export const ModalContentWrapper = styled(FlexColumn)`
  gap: 10px;

  @media (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    gap: 30px;
  }
`;

export const resetButtonStyles = (modalButton: boolean) => css`
  height: ${modalButton ? '60px' : '46px'};
  padding: 0;

  ${!modalButton &&
  css`
    > span {
      color: ${({ theme }) => theme.colors.text.primary};
    }
  `}
`;

export const AuthWrapper = styled(FlexCenterAligned)`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100vh;
  z-index: ${Z_INDEX_TO_HIDE_BANNERS};
  -webkit-backface-visibility: hidden;
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding-top: 25px;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    background-color: rgba(0, 0, 0, 0.5);
    padding-top: 0;
  }
`;

export const AuthIframe = styled.iframe`
  width: 100vw;
  height: 100vh;
  border: 0;

  @media screen and (min-width: ${({ theme }) => theme.tabletBreakpoint}) {
    width: 430px;
    height: 300px;
    position: relative;
    background: white;
    padding: 20px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  }
`;
